export class ListRestoreJobsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "RestoreJobsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortRestoreJobBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreJobsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
